import { render, staticRenderFns } from "./MetricCard.vue?vue&type=template&id=c361a6a6&scoped=true"
import script from "./MetricCard.vue?vue&type=script&lang=ts"
export * from "./MetricCard.vue?vue&type=script&lang=ts"
import style0 from "./MetricCard.vue?vue&type=style&index=0&id=c361a6a6&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c361a6a6",
  null
  
)

export default component.exports